
const DEFAULT_FOX = require("@/assets/image/global/icon_dialog_success.png");

export default {
  name: "XcoinsConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "",
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    illustration: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      innerVisible: false,
      optionTitle: "",
      optionMessage: "",
      optionConfirmText: "",
      optionCancelText: "",
      pending: null, // Promise 回调，仅 $xcoinsConfirm 打开时有值
    };
  },
  computed: {
    isVisible() {
      return this.visible || this.innerVisible;
    },
    dialogWidth() {
      return "455px";
    },
    resolvedTitle() {
      return this.optionTitle || this.title;
    },
    resolvedMessage() {
      return this.optionMessage || this.message;
    },
    resolvedConfirmText() {
      return this.optionConfirmText || this.confirmText || this.$t("page.CONFIRM");
    },
    resolvedCancelText() {
      return this.optionCancelText || this.cancelText || this.$t("page.CANCEL");
    },
    illustrationSrc() {
      return this.illustration || DEFAULT_FOX;
    },
  },
  methods: {
    /**
     * 编程式打开确认框，确认 resolve，取消/关闭 reject('cancel')。
     * @param {{ title?: string, message?: string, confirmText?: string, cancelText?: string }} options
     * @returns {Promise<true>}
     */
    open(options = {}) {
      if (this.pending) {
        this.settle(false);
      }
      this.optionTitle = options.title || "";
      this.optionMessage = options.message || "";
      this.optionConfirmText = options.confirmText || "";
      this.optionCancelText = options.cancelText || "";
      this.innerVisible = true;
      return new Promise((resolve, reject) => {
        this.pending = { resolve, reject };
      });
    },
    /** 关闭并按是否确认结束 Promise */
    settle(confirmed) {
      const pending = this.pending;
      this.pending = null;
      this.innerVisible = false;
      this.resetOptions();
      if (!pending) {
        return;
      }
      if (confirmed) {
        pending.resolve(true);
        return;
      }
      pending.reject("cancel");
    },
    resetOptions() {
      this.optionTitle = "";
      this.optionMessage = "";
      this.optionConfirmText = "";
      this.optionCancelText = "";
    },
    handleConfirm() {
      if (this.confirmLoading) {
        return;
      }
      this.$emit("confirm");
      if (this.pending) {
        this.settle(true);
        return;
      }
      this.$emit("update:visible", false);
    },
    /** 遮罩 / Esc / 取消都会走到这里；visible 已关掉时不再重复 reject */
    handleCancel() {
      if (!this.isVisible) {
        return;
      }
      this.$emit("cancel");
      this.$emit("close");
      if (this.pending) {
        this.settle(false);
        return;
      }
      this.$emit("update:visible", false);
    },
  },
};
